import React from 'react';
    import * as FiIcons from 'react-icons/fi';
    import { FiAlertTriangle } from 'react-icons/fi';

    const SafeIcon = ({ icon, name, className, ...props }) => {
      let IconComponent;

      try {
        // If an icon object is passed (e.g., imported directly)
        if (icon) {
          IconComponent = icon;
        } 
        // If a name string is passed
        else if (name) {
          // Normalize name to ensure it starts with 'Fi' if borrowing from Feather icons
          const iconName = name.startsWith('Fi') ? name : `Fi${name}`;
          IconComponent = FiIcons[iconName];
        }
      } catch (e) {
        console.error(`Failed to load icon: ${name}`, e);
        IconComponent = null;
      }

      // Fallback
      if (!IconComponent) {
        return <FiAlertTriangle className={className} {...props} />;
      }

      return <IconComponent className={className} {...props} />;
    };

    export default SafeIcon;